import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/login';
import JWTHelper from '@/jwt-token';
import DashboardView from '@/components/dashboard/dashboard.vue';
import ConfirmationPage from '@/components/service-log/history/confirmation-page/confirmation-page.vue';
import HistoryContainer from '@/components/service-log/history/history-container/history-container.vue';
import CreateSL from '@/components/service-log/form/create-service-log/create-service-log.vue';
import SlEdit from '@/components/service-log/form/edit-service-log/edit-service-log.vue';
import SlCopy from '@/components/service-log/form/copy-service-log/copy-service-log.vue';
import AgencyScheduler from '@/components/agency-scheduler/agency-scheduler-container/agency-scheduler-container.vue';
import SlSearch from '@/components/service-log/search/service-log-search.vue';
import Version from '../../version';

Vue.use(Router);

// auth guard, checks if the user-token is in local storage
function isAuthenticated(to, from, next) {
  if (!JWTHelper.isExpired()) {
    next();
    return;
  }
  next('/login');
}

function hasServiceLogRights(to, from, next) {
  if (!JWTHelper.isExpired() && JWTHelper.hasServiceLogRights()) {
    next();
    return;
  }
  next('/login');
}

// auth guard to make sure user is authenticated and an agency scheduler
function hasSchedulerRights(to, from, next) {
  if (!JWTHelper.isExpired() && JWTHelper.hasSchedulerRights()) {
    next();
    return;
  }
  next('/login');
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      beforeEnter: isAuthenticated
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/dashboard',
      component: DashboardView,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/create',
      component: CreateSL,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/confirmation/:sessionId',
      component: ConfirmationPage,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/history',
      component: HistoryContainer,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/edit/:sessionId',
      component: SlEdit,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/copy/:sessionId',
      component: SlCopy,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/search',
      component: SlSearch,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/agency-scheduler',
      component: AgencyScheduler,
      beforeEnter: hasSchedulerRights
    },
    {
      path: '/version',
      component: Version
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js